/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoodsMarketBarcodeReqVo
 */
export interface GoodsMarketBarcodeReqVo {
    /**
     * 第三方电商平台ID；为空时兼容旧请求并按 Coupang 处理。
     * 第三方电商平台ID；为空时按Coupang处理
     * @type {number}
     * @memberof GoodsMarketBarcodeReqVo
     */
    businessPlatformId?: number;
    /**
     * 平台条码。
     * 平台条码
     * @type {string}
     * @memberof GoodsMarketBarcodeReqVo
     */
    marketBarcode?: string;
    /**
     * 平台商品名称。
     * 平台商品名称
     * @type {string}
     * @memberof GoodsMarketBarcodeReqVo
     */
    marketProductName?: string;
    /**
     * 平台选项名称。
     * 平台选项名称
     * @type {string}
     * @memberof GoodsMarketBarcodeReqVo
     */
    marketOptionName?: string;
    /**
     * 平台选项ID。
     * 平台选项ID
     * @type {string}
     * @memberof GoodsMarketBarcodeReqVo
     */
    marketOptionId?: string;
}

/**
 * Check if a given object implements the GoodsMarketBarcodeReqVo interface.
 */
export function instanceOfGoodsMarketBarcodeReqVo(value: object): value is GoodsMarketBarcodeReqVo {
    return true;
}

export function GoodsMarketBarcodeReqVoFromJSON(json: any): GoodsMarketBarcodeReqVo {
    return GoodsMarketBarcodeReqVoFromJSONTyped(json, false);
}

export function GoodsMarketBarcodeReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoodsMarketBarcodeReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'businessPlatformId': json['businessPlatformId'] == null ? undefined : json['businessPlatformId'],
        'marketBarcode': json['marketBarcode'] == null ? undefined : json['marketBarcode'],
        'marketProductName': json['marketProductName'] == null ? undefined : json['marketProductName'],
        'marketOptionName': json['marketOptionName'] == null ? undefined : json['marketOptionName'],
        'marketOptionId': json['marketOptionId'] == null ? undefined : json['marketOptionId'],
    };
}

export function GoodsMarketBarcodeReqVoToJSON(json: any): GoodsMarketBarcodeReqVo {
    return GoodsMarketBarcodeReqVoToJSONTyped(json, false);
}

export function GoodsMarketBarcodeReqVoToJSONTyped(value?: GoodsMarketBarcodeReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'businessPlatformId': value['businessPlatformId'],
        'marketBarcode': value['marketBarcode'],
        'marketProductName': value['marketProductName'],
        'marketOptionName': value['marketOptionName'],
        'marketOptionId': value['marketOptionId'],
    };
}

